import React, { forwardRef } from "react";

const Input = forwardRef((props, ref) => {
  const {
    type,
    name,
    className,
    placeholder,
    value,
    handleChange,
    handleBlur,
    readonly,
    is_disabled,
  } = props;
  return (
    <>
      <input
        type={type}
        name={name}
        className={className}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        readOnly={readonly}
        disabled={is_disabled}
        ref={ref}
      />
    </>
  );
});

export default Input;
